import React from 'react';
import PropTypes from 'prop-types';
import { addDragListener } from 'utils/dragListener';
import { useDispatch } from 'react-redux';
import PatientNameHoldingStatusFlag from 'components/atoms/patientStatus/patientNameHoldingStatusFlag';
import { isBiller } from 'utils/userTypeHelper';
import Statusndicator from './statusIndicator';
import CcmStatusIndicator from './ccmStatusIndicator';
import ConsentIndicator from './consentIndicator';
import CallButton from './callButton';
import PCMIndicator from './pcmStatusIndicator';

const PatientRow = ({ data, roleNames }) => {
  const {
    connect: { handleConnectPopoutOpen, connectDetails },
  } = useDispatch();

  const onClickConnect = (phoneNumber, isRpmCall) => {
    const details = {
      phone: phoneNumber,
      guid: data.guid,
      isRpmCall,
    };
    connectDetails(details);
    handleConnectPopoutOpen(true);
    addDragListener('connect-modal', 'connect-modal-header');
  };
  return (
    <tr>
      <td data-label="Patient Name">
        <div className="adminPanel__row">
          <PatientNameHoldingStatusFlag
            title={data.title}
            firstName={data.firstName}
            middleName={data.middleName}
            lastName={data.lastName}
            holdingStatus={data.holdingStatus?.status}
            displayFlag={!isBiller(roleNames)}
            dataCy="adminPanel__patient-link"
            to={`/admin/patient/${data.guid}`}
          />
        </div>
      </td>
      <td data-label="Status" className="patient-status__row">
        <div className="adminPanel__row">
          <Statusndicator status={data.status} />
        </div>
      </td>
      <td data-label="Clinic">
        <div className="adminPanel__row-grid">
          <CcmStatusIndicator ccmStatus={data.ccmStatus} />
          <div className="mb-2" />
          <ConsentIndicator ccmConsentFormStatus={data.ccmConsentFormStatus} />
          {data.pcmStatus && (
            <>
              <div className="mb-2" />
              <PCMIndicator />
            </>
          )}
        </div>
      </td>
      <td data-label="Clinic">
        <div className="adminPanel__row">{data.clinic}</div>
      </td>
      <td>
        <div
          onClick={() => onClickConnect(data.phone, true)}
          className="adminPanel__row adminPanel__row--clickable"
        >
          <CallButton />
        </div>
      </td>
    </tr>
  );
};
PatientRow.propTypes = {
  data: PropTypes.shape().isRequired,
  roleNames: PropTypes.array,
};

export default PatientRow;
